/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rosy_Full_Heron_TalkInputs */

const en_rosy_full_heron_talk = /** @type {(inputs: Rosy_Full_Heron_TalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add manager`)
};

const de_rosy_full_heron_talk = /** @type {(inputs: Rosy_Full_Heron_TalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manager hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add manager" |
*
* @param {Rosy_Full_Heron_TalkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rosy_full_heron_talk = /** @type {((inputs?: Rosy_Full_Heron_TalkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rosy_Full_Heron_TalkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rosy_full_heron_talk(inputs)
	return de_rosy_full_heron_talk(inputs)
});